export const addReview = '/reviews';
export const reviews = '/reviews';
export const searchUser = '/user/reviewToUser/';
export const updateReview = '/reviews/';
export const getReviewDetails = '/reviews/';
